<template>
  <div>
    <div class="color-line"></div>
    <div class="error-container">
      <i class="pe-7s-lock text-info big-icon"></i>
      <h1>403</h1>
      <strong>Unauthorized Access</strong>
      <p>
        You do not have the access required to access this resource, maybe you can see with the reponsible or change your plan
      </p>
      <a role="button" @click="$router.go(-1)"><button class="btn btn-xs btn-info">Go back</button></a>
    </div>
  </div>

</template>
<script>

export default {
  name: 'Error403'
}
</script>



// WEBPACK FOOTER //
// src/components/error/Error403.vue